export enum ActionDialogType {
  ApproveResults = 'approve_results',
  BrightfieldTissueSegmentationMask = 'brightfield_tissue_segmentation_mask',
  CloudOptimizedSlides = 'cloud_optimized_slides',
  TileGeneration = 'tile_generation',
  AssignNeighborhoodNames = 'assign_generic_clusters',
  CreateCohort = 'create_cohort',
  CreateAssignment = 'create_assignment',
  AddToAssignment = 'add_to_assignment',
  PostProcessingAndCalculateFeatures = 'calculate_features',
  PostProcessingAndCalculateFeaturesSubMenu = 'calculate_features_sub_menu',
  Inference = 'inference',
  SlideRegistrations = 'slide_registrations',
  MultiplexCellSegmentation = 'multiplex_cell_segmentation',
  MultiplexThreshold = 'multiplex_threshold_binary_classification',
  MultiplexHistogram = 'multiplex_histogram_creation',
  MultiplexNormalization = 'multiplex_normalization',
  MultiplexBinaryClassifier = 'multiplex_binary_classification',
  MultiplexCellTyping = 'multiplex_cell_typing',
  RnaProbePeakDetection = 'rna_probe_peak_detection',
  MultiplexBlobSegmentation = 'multiplex_blob_segmentation',
  DetectTmaCores = 'detect_tma_cores',
  CropTma = 'crop_tma',
  ExecuteStudyAlgorithm = 'execute_study_algorithm',
  NeighborhoodClusters = 'neighborhood_clusters',
  CellSegmentation = 'cell_segmentation',
  CellQuantification = 'cell_quantification',
  MifMarkerUnsupervisedAnalysis = 'mif_marker_unsupervised_analysis',
  QaAnalysis = 'qa_analysis',
  QcAnalysis = 'qc_analysis',
  StudyReport = 'study_report',
  MultiplexTissueSegmentationMask = 'multiplex_tissue_segmentation_mask',
  ManualPostIngestPipeline = 'manual_post_ingest_pipeline',
  ApproveCases = 'approve_cases',
  DisapproveCases = 'disapprove_cases',
  PrepareCustomerResults = 'prepare_customer_results',
  BulkSlideTagging = 'bulk_slide_tagging',
  BulkMultiplexNormalization = 'bulk_multiplex_normalization',
  BulkMultiplexMarkerNaming = 'bulk_multiplex_marker_naming',
}
